import React from 'react'
import NavigationSelector from './Navigation/NavigationSelector'
export default function Header(props) {
  return <NavigationSelector {...props} />
}
